import productContentVideoSaga from '../../productContentVideo/sagas/ProductContentVideoSaga';
const loadProductContentVideoeModule = () => ({
    id: 'ProductContentVideos',
    sagas: [productContentVideoSaga],
});
export default loadProductContentVideoeModule;
